import {AreaNode, DepartmentNode, KPI_GROUP, KpiOption, TreeNode} from '../types'

export const mapAreaOptions = (options: AreaNode[]): KpiOption[] =>
  options.map((option) => ({
    id: option.upmId,
    label: option?.type?.name ?? option.text ?? option.upmId,
    group: KPI_GROUP.AREAS
  }))

export const mapDepartmentOptions = (options: DepartmentNode[]): KpiOption[] =>
  options.map((option) => ({
    id: option.upmId,
    label: option.displayValue ?? option?.type?.name ?? option.text ?? option.upmId,
    group: KPI_GROUP.DEPARTMENTS
  }))

export const enrichNodePath = <T extends TreeNode>(node: T, parentPath: string = ''): T => {
  const nodeCode = node.type?.code
  const nodePath = parentPath + (nodeCode ? (parentPath ? '_' : '') + nodeCode : '')

  const children = (node.children || []).map((child: TreeNode) => enrichNodePath(child, nodePath))
  return {
    ...node,
    children,
    entityCodesPath: nodePath
  }
}
